import axios from "axios";

export default axios.create({

    baseURL: "https://training-chp-api-dtfvadf6bxdgesff.centralindia-01.azurewebsites.net/"

});

